import {
  Clock,
  TicketStar,
  Location,
  TickSquare,
  ArrowUp2,
  ArrowDown2,
} from "iconsax-react";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { selectUser } from "../state/features/userSlice";
import { selectDrawer } from "../state/features/drawerSlice";
import { Input, DatePicker, Spin, Form, Empty, Button, Pagination } from "antd";
import execute from "../requests/frappe";
import moment from "moment";
import { useLocation, useNavigate } from "react-router-dom";
import GaugeChart from "react-gauge-chart";
import type { PaginationProps } from "antd";

export const Homepage = () => {
  const user = useSelector(selectUser);
  const drawer = useSelector(selectDrawer);
  const isLoggedIn = !!user;
  const navigate = useNavigate();
  let location = useLocation();
  let Params = new URLSearchParams(location.search);
  let status = Params.get("status");
  const { RangePicker } = DatePicker;
  const [data, setData] = useState<any>("");
  const [advancedFilter, setadvancedFilter] = useState<boolean>(false);
  const [uacFilter, setuacFilter] = useState<any>("");
  const [serviceFilter, setserviceFilter] = useState<any>("");
  const [nameFilter, setnameFilter] = useState<any>("");
  const [dateFilter, setdateFilter] = useState<any>([]);
  const [datevalue, setdateValue] = useState<any>([]);
  const [change, setChange] = useState<boolean>(false);
  const [zoneFilter, setzoneFilter] = useState<any>("");
  const [woredaFilter, setworedaFilter] = useState<any>("");
  const [kebeleFilter, setkebeleFilter] = useState<any>("");
  const [subcityFilter, setsubcityFilter] = useState<any>("");
  const [languageFilter, setlanguageFilter] = useState<any>("");

  const [form] = Form.useForm();
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);

  const onChange: PaginationProps["onChange"] = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const Fetch_Data = async () => {
    const temp_data =
      user &&
      (await execute("GET_APPLICATIONS", {
        // user: user?.name,
        status: status,
        filter: {
          uac: uacFilter,
          service: serviceFilter,
          name: nameFilter,
          date: dateFilter,
          zone: zoneFilter,
          woreda: woredaFilter,
          kebele: kebeleFilter,
          subcity: subcityFilter,
        },
      }));
    setData(temp_data);
  };

  useEffect(() => {
    setCurrentPage(1);
  }, [status]);

  useEffect(() => {
    

    setChange(true);
    if (data === "" || data === null || change) {
      Fetch_Data();
      setChange(false);
    }
  }, [
    uacFilter,
    serviceFilter,
    nameFilter,
    dateFilter,
    zoneFilter,
    woredaFilter,
    kebeleFilter,
    subcityFilter,
    languageFilter,
    advancedFilter,
    data,
    user,
    status,
  ]);

  const totalPages = Math.ceil(data?.app_list?.length / itemsPerPage);
  const startIndex = (currentPage - 1) * itemsPerPage;
  const endIndex = startIndex + itemsPerPage;

  const currentItems = data?.app_list?.slice(startIndex, endIndex);
  
  return (
    <>
      {isLoggedIn && (
        <div className="w-full mt-[6%] bg-general_bg ">
          <div
            className={`mb-5 nxl:fixed nxl:top-0 bg-general_bg ${drawer ? "lg:w-[91%] nxl:w-[86%]" : " lg:w-[91%] nxl:w-[78.2%]"
              }`}
          >
            <div className=" w-full mt-5 grid md:grid-cols-2 lg:grid-cols-3 nxl:grid-cols-7 gap-4 font-extralight mb-5">
              <div className="xsm:col-span-1 md:col-span-2 lg:col-span-3 nlg:col-span-2 bg-white rounded-md flex items-center">
                <p className="bg-blue text-white text-[20px] px-4 py-2.5 rounded-[50%] ml-8 mr-3 font-semibold my-4">
                  {user?.full_name[0]}
                </p>
                <p className="font-medium text-[20px]">Hi {user?.full_name},</p>
              </div>
              <GaugeChart
                className="xsm:col-span-1 md:col-span-2 lg:col-span-3 nlg:col-span-1 border-[1px] bg-[#E6E6E640] rounded-md"
                id="gauge-chart1"
                percent={data?.efficiency / 100}
                textColor={"#000"}
                hideText={false}
                nrOfLevels={3}
                arcWidth={0.25}
                needleColor={"#000"}
                // style={{height: '40%'}}
                // needleBaseColor={'#F0F1F2'}
                // marginInPercent={0.05}
                // previousValue={0.75}
                arcsLength={[0.5, 0.25, 0.25]}
                colors={["#EA4228", "#F5CD19", "#5BE12C"]}
                arcPadding={0.0}
                cornerRadius={1}
              />
              <div className="flex flex-col col-span-2 justify-between h-[90px] bg-dashboard_green rounded-md p-2 text-white">
                <p className="flex items-center font-semibold">
                  <Clock className="mx-2" size={15} />
                  completed steps
                </p>
                <p className=" mr-1 text-end font-bold text-[20px]">
                  {data?.eval_reviewed}
                </p>
              </div>
              <div className="flex flex-col col-span-2 justify-between h-[90px] bg-dashboard_blue rounded-md p-2 text-white">
                <p className="flex items-center font-semibold">
                  <Clock className="mx-2" size={15} />
                  pending steps
                </p>
                <p className=" mr-1 text-end font-bold text-[20px]">
                  {data?.pending_app}
                </p>
              </div>
              {/* <div className="flex flex-col col-span-1 justify-between h-[90px] bg-dashboard_purple rounded-md p-2 text-white">
                <p className="flex items-center font-semibold">
                  <Clock className="mx-2" size={15} />
                  Inprogress
                </p>
                <p className=" mr-1 text-end font-bold text-[20px]"> --</p>
              </div> */}

              {/* <div className="flex flex-col col-span-1 justify-between h-[90px] bg-dashboard_red rounded-md p-2 text-white">
                <p className="flex items-center font-semibold">
                  <Clock className="mx-2" size={15} />
                  Overdue
                </p>
                <p className=" mr-1 text-end font-bold text-[20px]"> --</p>
              </div> */}
            </div>
            <Button
              className=" right-0 w-20 col-span-1 h-8 rounded-md bg-white"
              onClick={() => {
                setuacFilter(undefined);
                setserviceFilter(undefined);
                setnameFilter(undefined);
                setzoneFilter(undefined);
                setworedaFilter(undefined);
                setkebeleFilter(undefined);
                setsubcityFilter(undefined);
                setlanguageFilter(undefined);
                setdateFilter([]);
                setdateValue([]);
                setChange(true);
                form.resetFields();
              }}
            >
              Clear
            </Button>

            <Form
              form={form}
              className=" grid md:grid-cols-2 lg:grid-cols-3 nxl:grid-cols-6 gap-4 font-extralight pb-5 "
            >
              <div className="">
                <p className=" ml-1 mb-2">By tracking Number</p>
                <Input
                  value={uacFilter}
                  placeholder="Enter uac"
                  className=" h-12 border-[#A1A1A1]"
                  onChange={(e) => {
                    setuacFilter(e.target.value);
                    setChange(true);
                  }}
                />
              </div>
              <div className="">
                <p className=" ml-1 mb-2">By Service</p>
                <Input
                  value={serviceFilter}
                  placeholder="Enter service name"
                  className=" h-12 border-[#A1A1A1]"
                  onChange={(e) => {
                    setserviceFilter(e.target.value);
                    setChange(true);
                  }}
                />
              </div>
              <div className="">
                <p className=" ml-1 mb-2">By Customer Name</p>
                <Input
                  value={nameFilter}
                  placeholder="Enter customer name"
                  className=" h-12 border-[#A1A1A1]"
                  onChange={(e) => {
                    setnameFilter(e.target.value);
                    setChange(true);
                  }}
                />
              </div>
              <div className=" lg:col-span-2">
                <p className=" ml-1 mb-2">Application start date</p>
                <RangePicker
                  className=" h-12 border-[#A1A1A1] w-full"
                  value={datevalue}
                  onChange={(dates, dateStrings) => {
                    setdateValue(dates);
                    setdateFilter(dateStrings);
                    setChange(true);
                  }}
                />
              </div>

              <Button
                className=" flex justify-center mt-7 col-span-1 h-12 rounded-md bg-[#E2ECFF] items-center "
                onClick={() => {
                  setadvancedFilter(!advancedFilter);
                }}
              >
                Advanced
                {advancedFilter ? (
                  <ArrowUp2 className="ml-2" size="18" />
                ) : (
                  <ArrowDown2 className="ml-2" size="18" />
                )}
              </Button>

              {advancedFilter && (
                <div className="flex gap-2">
                  <div className="">
                    <p className=" ml-1 mb-2">Zone</p>
                    <Input
                      value={zoneFilter}
                      placeholder="Enter Zone"
                      className=" h-12 border-[#A1A1A1]"
                      onChange={(e) => {
                        setzoneFilter(e.target.value);
                        setChange(true);
                      }}
                    />
                  </div>
                  <div className="">
                    <p className=" ml-1 mb-2">Woreda</p>
                    <Input
                      value={woredaFilter}
                      placeholder="Enter woreda"
                      className=" h-12 border-[#A1A1A1]"
                      onChange={(e) => {
                        setworedaFilter(e.target.value);
                        setChange(true);
                      }}
                    />
                  </div>
                </div>
              )}

              {advancedFilter && (
                <div className="flex gap-2">
                  <div className="">
                    <p className=" ml-1 mb-2">Kebele</p>
                    <Input
                      value={kebeleFilter}
                      placeholder="Enter kebele"
                      className=" h-12 border-[#A1A1A1]"
                      onChange={(e) => {
                        setkebeleFilter(e.target.value);
                        setChange(true);
                      }}
                    />
                  </div>
                  <div className="">
                    <p className=" ml-1 mb-2">Sub city</p>
                    <Input
                      value={subcityFilter}
                      placeholder="Enter sub city"
                      className=" h-12 border-[#A1A1A1]"
                      onChange={(e) => {
                        setsubcityFilter(e.target.value);
                        setChange(true);
                      }}
                    />
                  </div>
                </div>
              )}
            </Form>
          </div>

          <div
            className={`w-full pr-[1%] lg:pr-[9%] pb-5 ${advancedFilter ? "mt-[1%] nxl:mt-[22%]" : "nxl:mt-[16%]"
              }`}
          >
            {data?.app_list?.length < 1 && !data?.pending_app && (
              <div className=" mt-[35%] w-full flex items-center justify-center">
                <Spin size="large" />
              </div>
            )}

            {data?.app_list?.length < 1 && data?.pending_app && (
              <div className=" mt-[35%] w-full flex items-center justify-center">
                <Empty />
              </div>
            )}

            {data?.app_list?.length > 0 && currentItems && (
              <div className=" nxl:mt-[20%] flex flex-col ">
                {currentItems.map((app: any, index: number) => {
                  return (
                    app && (
                      <div
                        key={index}
                        className=" group bg-white my-2 md:flex py-5 px-4 xl:px-7 rounded-md cursor-pointer hover:shadow-[0_5px_30px_-15px_rgba(0,0,0,0.3)]"
                        onClick={() => {
                          navigate(`/application/${app.name}`);
                        }}
                      >
                        <div className=" flex justify-between flex-col md:w-[120%] xl:mr-3">
                          <div className=" flex justify-between items-center">
                            <div className="xsm:flex mb-1 items-center">
                              <div className=" h-12 w-12 rounded-[40px] mr-3 bg-[#1890FF] text-white font-[800] text-center flex justify-center py-3 px-3">
                                {(() => {
                                  const parts = app.full_name?.split(" ").filter(Boolean) || [];
                                  if (parts.length >= 2) {
                                    return parts[0][0] + "." + parts[1][0];
                                  }
                                  return parts[0]?.[0] || "?";
                                })()}

                              </div>
                              <div className=" w-full text-[20px] font-[700] group-hover:text-[#1890FF] group-hover:underline ">
                                {app.full_name}
                              </div>
                            </div>
                            <div className="flex flex-col xl:flex-row py-1  font-[400] text-[12px] border-[1px] border-[#017606] px-3 mr-2 rounded-md text-[#017606] w-fit items-center">
                              <span className="flex items-center pr-1">
                                <Clock
                                  size="15"
                                  className=" hidden lg:block mr-1 mb-[2px]"
                                />
                                {moment(app.creation).format("MMMM D, YYYY")}
                              </span>
                              {status !== "approved" ? (
                                <span className=" xl:ml-10 flex items-center mr-2 ">
                                  <TickSquare
                                    size="15"
                                    className=" hidden lg:block mr-1 mb-[2px]"
                                  />
                                  Evaluation Step:{" "}
                                  <p className=" ml-2 w-4 h-4 bg-card_blue text-white px-1 rounded-lg">
                                    {app.idx}
                                  </p>
                                </span>
                              ) : (
                                <p className=" xl:ml-10 flex items-center text-center mr-2 ">
                                  <TickSquare
                                    size="15"
                                    className=" hidden lg:block mr-1 mb-[2px]"
                                  />
                                  Completed
                                </p>
                              )}
                            </div>
                          </div>
                          <div className="flex xsm:ml-[60px] text-[14px] group-hover:text-[#1890FF] group-hover:underline">
                            <TicketStar
                              className=" mr-2 md:mr-1 "
                              size="25"
                              color="#FF0202"
                            />
                            {app.name}
                          </div>
                          <div className=" xsm:ml-[60px] flex text-[14px]">
                            <span className="font-[600] mr-2">Sector:</span>{" "}
                            {app.sector}
                          </div>
                        </div>

                        <div className=" text-[16px] mt-5 md:mt-0 pt-5 md:pt-0 md:w-[65%] border-t-[1px] md:border-t-[0px] border-l-[0px] md:border-l-[1px] border-dashed_border border-dashed flex flex-col pl-[2%] font-[400]">
                          <div className=" flex items-center mb-2">
                            <TicketStar
                              className=" mt-1 mr-2 md:mr-1 mb-1"
                              size="18"
                              color="#FF0202"
                            />
                            <span className="font-[600] mr-2">UAC:</span>{" "}
                            {app?.uac}
                          </div>

                          {/* TODO: Change */}

                          <div className=" mb-1 flex flex-wrap">
                            <span className="font-[600] mr-2 flex items-center">
                              <Location
                                color="#358B00"
                                className=" mr-2 md:mr-1 mb-1"
                                size="18"
                              />{" "}
                              City:
                            </span>
                            {app.region}
                            <span className=" ml-2 pl-4 lg:border-l-[1px] border-dashed_border lg:border-dashed font-[600] mr-2 flex items-center">
                              Sub city:
                            </span>
                            {app.sub_city}
                          </div>
                          <div className=" mb-2 flex flex-wrap">
                            <span className=" ml-4 pl-2 font-[600] mr-2 flex items-center ">
                              Woreda :
                            </span>
                            {app.woreda}
                          </div>
                        </div>
                      </div>
                    )
                  );
                })}

                <Pagination
                  className="mx-auto mt-10 items-center"
                  showQuickJumper
                  showTitle
                  defaultCurrent={1}
                  // pageSize={3}
                  total={data?.app_list?.length}
                  onChange={onChange}
                  showSizeChanger
                  pageSizeOptions={["10", "20", "50"]} // Options for items per page
                  onShowSizeChange={(current, pageSize) => {
                    setItemsPerPage(pageSize);
                  }}
                />
              </div>
            )}
          </div>
        </div>
      )}
    </>
  );
};
